import { BaseService } from '@app/core/services/base-service.service';
import { GenericMemberResponsePortalResponseDto } from '@app/core/models/genericMembeResponsePortalResponseDto';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SocialSecurityBenefitsDto } from '../model/socialSecurityBenefitsDto';

@Injectable({
  providedIn: 'root'
})
export class SocialSecurityBenefitsService extends BaseService {

    //#region Constructor
    constructor(http: HttpClient) {
        super(http);
    }
     //#endregion Constructor

    //#region Public Methods
    public Save(socialSecurityBenefitsDto: SocialSecurityBenefitsDto): Observable<GenericMemberResponsePortalResponseDto<SocialSecurityBenefitsDto>> {
        return this.Post('/Survey/SocialSecurityBenefits', socialSecurityBenefitsDto);
    }
    //#endregion Public Methods
}

